/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import css from 'styled-jsx/css';
import { sizes } from '@styles/theme';

export default css.global`
  /* Animations */
  .floating {
    height: 40vmin;
    pointer-events: none;
  }

  .text-tool-caret {
    animation-name: caret-blink;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(1, 0, 0, 1);
    animation-duration: 1s;
  }

  .loading-spinner {
    position: absolute;
    top: calc(50% - ${sizes.base});
    left: calc(50% - ${sizes.base});
    width: ${sizes.tera};
    height: ${sizes.tera};
  }

  .loading-spinner img {
    position: relative;
    top: 0;
    left: 0;
    animation-name: rotate-spinner;
    animation-duration: 0.6s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @media (prefersreduced-motion: no-preference) {
    .floating {
      animation: element-float infinite 3s ease-in-out;
    }
  }
  @keyframes element-float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(30px);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes caret-blink {
    from {
      opacity: 0.1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes rotate-spinner {
    from: {
      transform: rotate(0deg);
    }
    to: {
      transform: rotate(360deg);
    }
  }
  .loader {
    margin: 100px auto;
    font-size: 4px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: loading 1.1s infinite ease;
    transform: translateZ(0);
    &.medium {
      font-size: 8px;
      margin-top: 50px;
    }
    &.large {
      font-size: 10px;
      margin-top: 150px;
    }
  }
  @-webkit-keyframes loading {
    0%,
    100% {
      box-shadow: 0em -2.6em 0em 0em #d5d5d5, 1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2),
        2.5em 0em 0 0em rgba(213, 213, 213, 0.2), 1.75em 1.75em 0 0em rgba(213, 213, 213, 0.2),
        0em 2.5em 0 0em rgba(213, 213, 213, 0.2), -1.8em 1.8em 0 0em rgba(213, 213, 213, 0.2),
        -2.6em 0em 0 0em rgba(213, 213, 213, 0.5), -1.8em -1.8em 0 0em rgba(213, 213, 213, 0.7);
    }
    12.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(213, 213, 213, 0.7), 1.8em -1.8em 0 0em #d5d5d5,
        2.5em 0em 0 0em rgba(213, 213, 213, 0.2), 1.75em 1.75em 0 0em rgba(213, 213, 213, 0.2),
        0em 2.5em 0 0em rgba(213, 213, 213, 0.2), -1.8em 1.8em 0 0em rgba(213, 213, 213, 0.2),
        -2.6em 0em 0 0em rgba(213, 213, 213, 0.2), -1.8em -1.8em 0 0em rgba(213, 213, 213, 0.5);
    }
    25% {
      box-shadow: 0em -2.6em 0em 0em rgba(213, 213, 213, 0.5), 1.8em -1.8em 0 0em rgba(213, 213, 213, 0.7),
        2.5em 0em 0 0em #d5d5d5, 1.75em 1.75em 0 0em rgba(213, 213, 213, 0.2), 0em 2.5em 0 0em rgba(213, 213, 213, 0.2),
        -1.8em 1.8em 0 0em rgba(213, 213, 213, 0.2), -2.6em 0em 0 0em rgba(213, 213, 213, 0.2),
        -1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2);
    }
    37.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(213, 213, 213, 0.2), 1.8em -1.8em 0 0em rgba(213, 213, 213, 0.5),
        2.5em 0em 0 0em rgba(213, 213, 213, 0.7), 1.75em 1.75em 0 0em #d5d5d5, 0em 2.5em 0 0em rgba(213, 213, 213, 0.2),
        -1.8em 1.8em 0 0em rgba(213, 213, 213, 0.2), -2.6em 0em 0 0em rgba(213, 213, 213, 0.2),
        -1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2);
    }
    50% {
      box-shadow: 0em -2.6em 0em 0em rgba(213, 213, 213, 0.2), 1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2),
        2.5em 0em 0 0em rgba(213, 213, 213, 0.5), 1.75em 1.75em 0 0em rgba(213, 213, 213, 0.7), 0em 2.5em 0 0em #d5d5d5,
        -1.8em 1.8em 0 0em rgba(213, 213, 213, 0.2), -2.6em 0em 0 0em rgba(213, 213, 213, 0.2),
        -1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2);
    }
    62.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(213, 213, 213, 0.2), 1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2),
        2.5em 0em 0 0em rgba(213, 213, 213, 0.2), 1.75em 1.75em 0 0em rgba(213, 213, 213, 0.5),
        0em 2.5em 0 0em rgba(213, 213, 213, 0.7), -1.8em 1.8em 0 0em #d5d5d5, -2.6em 0em 0 0em rgba(213, 213, 213, 0.2),
        -1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2);
    }
    75% {
      box-shadow: 0em -2.6em 0em 0em rgba(213, 213, 213, 0.2), 1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2),
        2.5em 0em 0 0em rgba(213, 213, 213, 0.2), 1.75em 1.75em 0 0em rgba(213, 213, 213, 0.2),
        0em 2.5em 0 0em rgba(213, 213, 213, 0.5), -1.8em 1.8em 0 0em rgba(213, 213, 213, 0.7), -2.6em 0em 0 0em #d5d5d5,
        -1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2);
    }
    87.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(213, 213, 213, 0.2), 1.8em -1.8em 0 0em rgba(213, 213, 213, 0.2),
        2.5em 0em 0 0em rgba(213, 213, 213, 0.2), 1.75em 1.75em 0 0em rgba(213, 213, 213, 0.2),
        0em 2.5em 0 0em rgba(213, 213, 213, 0.2), -1.8em 1.8em 0 0em rgba(213, 213, 213, 0.5),
        -2.6em 0em 0 0em rgba(213, 213, 213, 0.7), -1.8em -1.8em 0 0em #d5d5d5;
    }
  }
`;
